import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

//import image from "../../../images/where-do-my-taxes-go.png";

const WhereDoMyTaxesGoImage = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "where-do-my-taxes-go_med.png" }) {
        childImageSharp {
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img fluid={data.placeholderImage.childImageSharp.fluid} />
}

export default WhereDoMyTaxesGoImage
